import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import diacritics from 'diacritics';

export default {
  crudController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'authService',
    '$state',
    'webApiSettings',
    '$uibModal',
    '$filter',
    'service',
    'validationService',
    'FileUploader',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      authService,
      $state,
      webApiSettings,
      uibModal,
      $filter,
      service,
      validationService,
      FileUploader
    ) {
      'use strict';

      var countUsers = '';
      var usersLimit =
        authService.getLoggedCompany().Company.Contract.UsersLimit;
      var usersCount =
        authService.getLoggedCompany().Company.Contract.UserCount;

      if (usersLimit > usersCount) {
        countUsers = usersLimit - usersCount;
      } else {
        countUsers = usersCount - usersLimit;
      }

      var authData = authService.authentication;
      var isauth = authData.token !== null && authData.token !== '';

      var uploader = ($scope.uploader = new FileUploader({
        url: webApiSettings.apiServiceBaseUri + 'companies/new',
        removeAfterUploading: true,
        headers: {
          Authorization: isauth ? 'Bearer ' + authData.token : '',
        },
      }));

      function onErrorItem(fileItem, response) {
        swal.fire({
          icon: 'error',
          title: response.Message,
          text: response.ExceptionMessage,
          showCancelButton: false,
          confirmButtonText: 'OK',
        });
      }

      function onCompleteItem() {
        $state.go($scope.$parent.states.list);
      }

      function onCrudCurrentItemEvent(event, args) {
        event.currentScope.$parent.currentItem[args.event](args.params);
      }

      function parent_isSysAdmin() {
        return authService.isSysAdmin();
      }

      function parent_isLoading() {
        return $scope.loading || !authService.user.email;
      }

      function loadMore() {
        $scope.$parent.totalDisplayed += 50;
      }

      function updateUserCount(company) {
        $scope.$parent.currentItem.allCompanies.forEach(function (item) {
          if (item.contract.id === company.contract.id) {
            company.selected
              ? item.contract.userCount++
              : item.contract.userCount--;
          }
        });
      }

      function isEnabled(company) {
        if (
          company.contract.usersLimit === 0 ||
          company.selected ||
          $scope.$parent.currentItem.isSysAdmin
        ) {
          return true;
        }

        var enabled = $scope.$parent.currentItem.allCompanies.filter(
          function (item) {
            if (
              item.selected &&
              item.id !== company.id &&
              item.contract.id === company.contract.id
            ) {
              return true;
            }
          }
        );

        return (
          enabled.length > 0 ||
          company.contract.usersLimit - company.contract.userCount > 0
        );
      }

      function canAddNewUser() {
        if ($scope.$parent.currentItem.id !== 0) return true;

        return (
          $scope.$parent.isSysAdmin() ||
          ($scope.$parent.currentItem.allCompanies &&
            $scope.$parent.currentItem.allCompanies[0].contract.usersLimit ===
              0) ||
          ($scope.$parent.currentItem.allCompanies &&
            $scope.$parent.currentItem.allCompanies[0].contract.usersLimit -
              $scope.$parent.currentItem.allCompanies[0].contract.userCount >
              0)
        );
      }

      function ignoreDolarSign(event) {
        if (event.keyCode === 36) {
          event.preventDefault();
        }
      }

      function hasPermission() {
        return service.hasPermission();
      }

      function sort(column) {
        if (!$scope.sortingColumn || $scope.sortingColumn === column) {
          column.sortOrder = column.sortOrder === 'asc' ? 'desc' : 'asc';
        }

        var sort = function (a, b) {
          return $scope.sortOperation(a, b, column);
        };
        $scope.itens.sort(sort);
        $scope.sortingColumn = column;
      }

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = $scope.sortText(a, b, column);
            break;
          case 'number':
            res = $scope.sortNumber(a, b, column);
            break;
          case 'date':
            res = $scope.sortDate(a, b, column);
            break;
        }

        if (column.sortOrder === 'desc') {
          return res * -1;
        }

        return res;
      }

      function sortText(a, b, column) {
        var sort1 = $filter('reflect')(a, column.column);
        if (sort1 === undefined) {
          sort1 = '';
        }
        var sort2 = $filter('reflect')(b, column.column);
        if (sort2 === undefined) {
          sort2 = '';
        }
        return sort1.toString().localeCompare(sort2);
      }

      function sortNumber(a, b, column) {
        return (
          $filter('reflect')(a, column.column) -
          $filter('reflect')(b, column.column)
        );
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        firstDate = $filter('reflect')(a, column.column);
        secDate = $filter('reflect')(b, column.column);

        if (firstDate > secDate) {
          return 1;
        }

        if (firstDate < secDate) {
          return -1;
        }
      }

      function parent_filter(item) {
        if ($scope.filterQuery !== '') {
          var filter = diacritics.remove($scope.filterQuery).toLowerCase();
          var title = diacritics.remove(item.title()).toLowerCase();
          var details = item.details();
          var detail = details ? diacritics.remove(details).toLowerCase() : '';

          return (
            item.removed !== 1 &&
            (title.indexOf(filter) > -1 || detail.indexOf(filter) > -1)
          );
        }
        return item.removed !== 1;
      }

      function parent_removedFilter(item) {
        return item.removed !== 1;
      }

      function parent_sortLimit() {
        if (usersLimit === 0) {
          return 'Licenças Ilimitadas';
        } else if (countUsers === usersLimit) {
          return (
            'Quantidade máxima de usuários atingida | ' +
            usersLimit +
            ' ' +
            $filter('translate')('USERS CONTRACTED')
          );
        } else if (countUsers === 1) {
          return (
            countUsers +
            ' Usuario disponivel | ' +
            usersLimit +
            ' ' +
            $filter('translate')('USERS CONTRACTED')
          );
        } else if (countUsers === 0) {
          return (
            'Nenhum usuário disponivel | ' +
            usersLimit +
            ' ' +
            $filter('translate')('USERS CONTRACTED')
          );
        } else {
          return (
            countUsers +
            ' Usuarios disponiveis | ' +
            usersLimit +
            ' ' +
            $filter('translate')('USERS CONTRACTED')
          );
        }
      }

      function loadActions() {
        service.extraActions().then(function (result) {
          $rootScope.extraActions = result;
        });
      }

      function loadFilters() {
        service.listFilters().then(function (result) {
          $scope.listFilters = result;
        });
      }

      function parent_selectedItems() {
        return $scope.$parent
          ? $scope.$parent.itens.filter(function (i) {
              return i.selected === true;
            })
          : null;
      }

      function list(filter) {
        $scope.$parent.currentItem = null;
        $scope.$parent.totalDisplayed = 50;

        if ($scope.listFilters) {
          $scope.listFilters.forEach(function (f) {
            f.selected = false;
          });
          var select = $scope.listFilters.filter(
            (f) => f.filter === filter.filter
          )[0];

          if (select) select.selected = true;
        }

        $scope.loading = true;

        service
          .list(filter)
          .then(function (result) {
            $scope.$parent.itens = result;
            $scope.loading = false;
          })
          .catch(function () {
            $scope.loading = false;
          });
      }

      function loadItem() {
        $scope.itemLoaded = false;
        $scope.loading = true;
        $scope.loadItemPromise = service.load($scope.id).then(
          function (result) {
            $scope.$parent.currentItem = result;

            if ($scope.$parent.currentItem['itemsArray'] !== undefined) {
              $scope.$parent.currentItem['itemsArray'] =
                $scope.$parent.currentItem['itemsArray'].filter(
                  function (elem, pos, self) {
                    return self.indexOf(elem) === pos;
                  }
                );
            }
            $scope.itemLoaded = true;
            if ($scope.tabDataLoaded) {
              $scope.loading = false;
            }
          },
          function () {
            $scope.loading = false;
          }
        );
      }

      function loadTabData(tab) {
        $scope.tabDataLoaded = false;

        $scope.loadItemPromise.then(
          function () {
            service.loadData(tab, $scope.$parent.currentItem).then(
              function () {
                $scope.tabDataLoaded = true;
                if ($scope.itemLoaded) {
                  $scope.loading = false;
                }
              },
              function () {
                $scope.loading = false;
              }
            );
          },
          function () {
            $scope.loading = false;
          }
        );
      }

      function selectAll(items) {
        items.forEach(function (i) {
          i.selected = $scope.checkboxAll;
        });
      }

      function validityModelState(keyToClear) {
        var isValid = true;
        var BreakException = {};
        try {
          if ($scope.$parent.modelState) {
            if ($scope.$parent.modelState[keyToClear]) {
              $scope.$parent.modelState[keyToClear] = [];
            }
            Object.keys($scope.$parent.modelState).forEach(function (key) {
              if (
                !key.startsWith('$') &&
                $scope.$parent.modelState[key].length > 0
              ) {
                isValid = false;
                throw BreakException;
              }
            });
          }
        } catch (e) {
          if (e !== BreakException) {
            throw e;
          }
        }
        if ($scope.newForm) {
          if (isValid) {
            $scope.newForm.$setValidity('newForm.$error.modelState', true);
          } else {
            $scope.newForm.$setValidity('newForm.$error.modelState', false);
          }
        }
      }

      function userHasTimeLimit() {
        $rootScope.timeCheckModal = uibModal.open({
          animation: true,
          templateUrl: '/views/modules/security/users/timecheck.html',
          controller: 'timecheckController',
          backdrop: 'static',
          keyboard: true,
          size: 'm',
          resolve: {
            userSelected: () => $scope.$parent.currentItem,
          },
        });
      }

      function isCpfValid(value) {
        if (
          $scope.$parent.currentItem.cpf &&
          $scope.$parent.currentItem.cpf !== ''
        ) {
          return validationService.validateCPF(value);
        }
        return true;
      }

      function save() {
        $scope.$parent.selectedTab = 'dados';
        $scope.$parent.modelState = null;

        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          icon: 'info',
        });

        if (!$scope.$parent.currentItem.isValid()) {
          swal.fire({
            title: $filter('translate')('REQUIRED FIELDS'),
            text: $filter('translate')('REQUIRED FIELD MSG'),
            showCancelButton: false,
            confirmButtonText: $filter('translate')('OK'),
          });
          return;
        }

        service.save($scope.$parent.currentItem).then(
          function () {
            swal.close();
            $state.go($scope.$parent.states.list);
          },
          function (error) {
            $scope.$parent.modelState = error.modelState;
            if ($scope.$parent.modelState && $scope.newForm) {
              $scope.newForm.$setValidity('newForm.$error.modelState', false);
            }

            var msg = '';
            if (
              $scope.$parent.modelState &&
              $scope.$parent.modelState['Limit']
            ) {
              msg += '\n' + $scope.$parent.modelState['Limit'];
              $scope.$parent.modelState['Limit'] = [];
            }
            swal.fire({
              title: error.title,
              text: error.text + msg,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        );
      }

      function save2() {
        if (uploader.queue.length > 0) {
          var item = uploader.queue;
          item[0].formData = [
            {
              company: angular.toJson($scope.$parent.currentItem),
            },
          ];

          item[0].upload();
        } else {
          $scope.save();
        }
      }

      function edit() {}

      function cancel() {
        $state.go($scope.$parent.states.list);
      }

      function reset() {}

      function parent_delete() {
        $scope.itensDeleted = $scope.selectedItems();
        $scope.messageTitle = $filter('translate')('CONFIRM REMOVE');
        $scope.messageDescription = 'Essa operação não pode ser revertida.';
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'deleteModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            itens: () => $scope.itensDeleted,
            load: () => $scope.loadItem(),
            service: service,
          },
        });
      }

      function run() {
        try {
          uploader.onErrorItem = onErrorItem;
          uploader.onCompleteItem = onCompleteItem;

          $scope.$parent.title = $state.current.data.title;
          $scope.$parent.states =
            $state.current.data.states === undefined
              ? {}
              : $state.current.data.states;
          $scope.customDeleteMessage = $state.current.data.customDeleteMessage;
          $scope.$parent.crudTitle = $state.current.data.crudTitle;
          $scope.$parent.selectedTab = $state.params.tab
            ? $state.params.tab
            : 'dados';

          $scope.loading = true;
          $scope.filterQuery = '';
          $scope.sortColumns = service.sortColumns();
          $scope.listFilters = null;
          $scope.id = $state.params.id;
          $scope.checkboxAll = false;
          $scope.$parent.modelState = null;
          $scope.$parent.itens = [];
          $scope.$parent.currentItem = {};
          $scope.$parent.currentItem.d4SignTokenApi = null;
          $scope.$parent.currentItem.d4SignCriptKey = null;
          $scope.$parent.currentItem.cofre = 'Digitaldoc';
          $scope.$parent.totalDisplayed = 50;
          $scope.sortingColumn = null;
          $scope.itemLoaded = true;
          $scope.tabDataLoaded = true;

          $scope.$on(
            'crudCurrentItemEvent',
            logWrapper(
              onCrudCurrentItemEvent,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.$parent.isSysAdmin = logWrapper(
            parent_isSysAdmin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.isLoading = logWrapper(
            parent_isLoading,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadMore = logWrapper(
            loadMore,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateUserCount = logWrapper(
            updateUserCount,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isEnabled = logWrapper(
            isEnabled,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canAddNewUser = logWrapper(
            canAddNewUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.ignoreDolarSign = logWrapper(
            ignoreDolarSign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasPermission = logWrapper(
            hasPermission,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sort = logWrapper(
            sort,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortOperation = logWrapper(
            sortOperation,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortText = logWrapper(
            sortText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortNumber = logWrapper(
            sortNumber,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortDate = logWrapper(
            sortDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.filter = logWrapper(
            parent_filter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.removedFilter = logWrapper(
            parent_removedFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.sortLimit = logWrapper(
            parent_sortLimit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadActions = logWrapper(
            loadActions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFilters = logWrapper(
            loadFilters,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.selectedItems = logWrapper(
            parent_selectedItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.list = logWrapper(
            list,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadItem = logWrapper(
            loadItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadTabData = logWrapper(
            loadTabData,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectAll = logWrapper(
            selectAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validityModelState = logWrapper(
            validityModelState,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.userHasTimeLimit = logWrapper(
            userHasTimeLimit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isCpfValid = logWrapper(
            isCpfValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save2 = logWrapper(
            save2,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.edit = logWrapper(
            edit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.reset = logWrapper(
            reset,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.delete = logWrapper(
            parent_delete,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
